import React from 'react';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';

/** The values the users table's Status filter holds. */
export const ACTIVE = 'active';
export const INACTIVE = 'inactive';

const OPTIONS = [
	{ id: ACTIVE, name: 'Active' },
	{ id: INACTIVE, name: 'Inactive' },
];

/**
 * Pick Active and / or Inactive, to filter users by whether they're active. value/onChange
 * are ACTIVE / INACTIVE (an array when multiple, the default). Other props go to
 * ResponsiveAutocomplete.
 */
export const UserStatusPicker = ({ multiple = true, ...props }) => (
	<ResponsiveAutocomplete options={OPTIONS} multiple={multiple} {...props} />
);
